import { Reveal } from "./Reveal";
import { Button } from "@/components/ui/button";
import { trackCtaClick } from "@/lib/analytics";

export function FinalCTASection() {
  return (
    <section className="relative overflow-hidden py-10 md:py-14">
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(ellipse_at_center,_color-mix(in_oklab,_var(--gold)_10%,_transparent)_0%,_transparent_70%)]" />
      <div className="container-narrow text-center">
        <Reveal as="p" duration={0.6}
          className="mb-5 text-[11px] font-bold uppercase tracking-[0.22em] text-gold"
        >
          Decisão
        </Reveal>

        <Reveal as="h2" y={24} duration={0.8}
          className="mx-auto max-w-3xl text-balance text-3xl leading-tight text-ivory md:text-5xl lg:text-6xl"
        >
          Você já entendeu o problema. Já entendeu a solução.{" "}
          <span className="italic text-gold-soft">
            Faltam 4 sessões.
          </span>
        </Reveal>

        <Reveal as="p" duration={0.7} delay={0.15}
          className="mx-auto mt-7 max-w-2xl text-pretty text-base text-slate-muted md:text-lg"
        >
          O mercado de IA está mudando semana a semana.{" "}
          <span className="text-ivory/90">
            Quem mapear e configurar agora leva vantagem competitiva real
          </span>{" "}
          enquanto o concorrente ainda está pensando em começar.
        </Reveal>

        <Reveal as="p" duration={0.7} delay={0.25}
          className="mx-auto mt-5 max-w-xl text-pretty text-base text-slate-muted md:text-lg"
        >
          Se quiser sair do uso raso de IA e ter a sua operação rodando com um
          time de agentes construído com você —{" "}
          <span className="text-ivory">é aqui.</span>
        </Reveal>

        <Reveal y={12} duration={0.6} delay={0.35}
          className="mt-10"
        >
          <Button
            asChild
            size="lg"
            className="h-14 bg-gradient-gold px-12 text-base text-primary-foreground hover:opacity-90"
          >
            <a href="#inscricao" onClick={() => trackCtaClick("final_cta", "Quero meu Sprint Code")}>Quero meu Sprint Code</a>
          </Button>
          <p className="mx-auto mt-5 max-w-md text-xs text-slate-muted">
            Após o pagamento: conversa de 20 minutos com a Leilaine para
            definir a agenda das 4 sessões e o foco de cada uma.
          </p>
          <p className="mt-6 text-[11px] font-bold uppercase tracking-[0.22em] text-gold/80">
            SPRINT CODE · Individual ou grupo fechado
          </p>
        </Reveal>
      </div>
    </section>
  );
}
